module.exports = __webpack_public_path__ + "static/media/logo.18c10e84.jpg";